export interface SessionHistoryItem {
  sessionId: string;
  date: string; // ISO string
  matchCount: number;
}

const STORAGE_KEY = 'swipeeat_session_history';
const MAX_ITEMS = 10;

export function getHistory(): SessionHistoryItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as SessionHistoryItem[];
  } catch {
    return [];
  }
}

export function saveSession(sessionId: string): void {
  const history = getHistory();
  const existing = history.find((h) => h.sessionId === sessionId);
  if (existing) return; // already saved

  history.unshift({
    sessionId,
    date: new Date().toISOString(),
    matchCount: 0,
  });

  // Keep only last N
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, MAX_ITEMS)));
}

export function updateSessionHistory(sessionId: string, matchCount: number): void {
  const history = getHistory();
  const item = history.find((h) => h.sessionId === sessionId);
  if (item) {
    item.matchCount = matchCount;
  } else {
    history.unshift({
      sessionId,
      date: new Date().toISOString(),
      matchCount,
    });
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, MAX_ITEMS)));
}

export function clearHistory(): void {
  localStorage.removeItem(STORAGE_KEY);
}
